export default __webpack_public_path__ + "static/media/AITT_white.e927a88d.jpg";